import { render, staticRenderFns } from "./ExternalGameTab.vue?vue&type=template&id=cf8a1406&scoped=true&lang=pug"
import script from "./ExternalGameTab.vue?vue&type=script&lang=js"
export * from "./ExternalGameTab.vue?vue&type=script&lang=js"
import style0 from "./ExternalGameTab.vue?vue&type=style&index=0&id=cf8a1406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8a1406",
  null
  
)

export default component.exports